import React, { useState, useEffect, useRef } from 'react';

function TodoForm(props) {
  const [input, setInput] = useState(props.edit ? props.edit.value : '');
  

  const inputRef = useRef(null);
  
  const handleChange = e => {
    setInput(e.target.value);
 
  };
  useEffect(() => {
    inputRef.current.focus();
    
    
  }, []);


  const handleSubmit = e => {
    e.preventDefault();
   
    props.onSubmit({
      id: Math.floor(Math.random() * 100000),
      text: input
    });
    
   
    
    
    setInput('');
  };

  return (
    <form onSubmit={handleSubmit} className='todo-form'>
      {props.edit ? (
        <>
          <textarea
            placeholder='Update your Memo'
            value={input}
            onChange={handleChange}
            name='text'
            ref={inputRef}
            className='todo-input edit'
          />
          <button onClick={handleSubmit} className='todo-button edit'>
            Update Memo
          </button>
        </>
      ) : (
        <>
          <textarea
            placeholder='Add a Memo'
            value={input}
            onChange={handleChange}
            name='text'
            className='todo-input'
            ref={inputRef}
          />
          <button onClick={handleSubmit} className='todo-button'>
            Add Memo
          </button>
        </>
      )}
    </form>
  );
}

export default TodoForm;
